import { Injectable, Injector } from '@angular/core';
import { SynchronizationServiceBase } from './synchronization-service-base';
import { SynchronizationEntity } from './synchronization-entity';
import { MachineRepository } from '../local-db/repositories/machine-repository';

@Injectable({ providedIn: 'root' })
export class MachineSyncService extends SynchronizationServiceBase {
    constructor(
        injector: Injector,
        private readonly _machineRepo: MachineRepository
    ) {
        super(injector, SynchronizationEntity.Machines);
    }

    public async synchronize(): Promise<void> {
        await this._machineRepo.refreshMachines();
    }
}
